import { Dialog, Grid, IconButton } from '@mui/material';
import React from 'react';
import { formatPriceBreakupValues } from '../../../Utils/helperFns';
import Images from '../../../Utils/images';

/** Cumulative mileage and other charges for multiple shifts (e.g. all shifts in a worksheet) */
function AdditionalChargesModal({
  open,
  onClose,
  shifts = [],
}: {
  open: boolean;
  onClose: () => void;
  shifts: any[];
}) {
  const totals = React.useMemo(() => {
    let totalMileageDistance = 0;
    let totalMileageCost = 0;
    let totalPerDiemCost = 0;
    let totalRushFee = 0;
    let totalMileageRate = 0;
    (shifts || []).forEach((s: any) => {
      totalMileageDistance += Number(s?.mileageDistance) || 0;
      totalMileageCost += Number(s?.mileageCost) || 0;
      totalPerDiemCost += Number(s?.perDiemCost) || 0;
      totalRushFee += Number(s?.rushFee) || 0;
      totalMileageRate += Number(s?.mileageRate) || 0;
    });
    return {
      totalMileageDistance,
      totalMileageCost,
      totalPerDiemCost,
      totalRushFee,
      totalMileageRate,
      totalAdditional: totalMileageCost + totalPerDiemCost + totalRushFee,
    };
  }, [shifts]);

  const hasRushFee = React.useMemo(
    () => (shifts || []).some((s: any) => s?.rushFeeApplied),
    [shifts],
  );

  return (
    <Dialog open={open} onClose={onClose}>
      <div className="dialogWrapper warning orderAddress w__368">
        <div className="dialogHeader flex sps_between">
          View Additional Charges
          <IconButton onClick={onClose}>
            <img src={Images.CLOSE} alt="Close" />
          </IconButton>
        </div>

        <div className="doalogBody small body-scroll-sm body-right-space">
          <div className="formContainer">
            <Grid container spacing={2}>
              <Grid item md={12} xs={12}>
                <div className="price_breakup_list">
                  <h3>
                    Mileage (
                    {formatPriceBreakupValues(totals.totalMileageDistance)}{' '}
                    miles) X ${totals.totalMileageRate || 0}{' '}
                    <strong>
                      ${formatPriceBreakupValues(totals.totalMileageCost)}
                    </strong>
                  </h3>

                  <h3>
                    Rush Fee{' '}
                    <strong>
                      ${formatPriceBreakupValues(totals.totalRushFee || 0)}
                    </strong>
                  </h3>

                  <h3>
                    Per Diem{' '}
                    <strong>
                      ${formatPriceBreakupValues(totals.totalPerDiemCost)}
                    </strong>
                  </h3>

                  <div className="divider"></div>
                  <h3>
                    Total Additional Charges{' '}
                    <strong>
                      ${formatPriceBreakupValues(totals.totalAdditional)}
                    </strong>
                  </h3>
                  <div className="divider"></div>
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </Dialog>
  );
}

export default AdditionalChargesModal;
